export const EVENT_PROPERTIES_PREFIX = 'event_properties';

export const wrapWithEventPropertiesPrefix = (obj: Record<string, unknown>) => {
  try {
    return Object.fromEntries(
      Object.entries(obj).map(([key, value]) => [
        `${EVENT_PROPERTIES_PREFIX}.${key}`,
        value,
      ]),
    );
  } catch {
    return {
      [`${EVENT_PROPERTIES_PREFIX}.data`]:
        'Failed to wrap with event properties prefix',
    };
  }
};
